import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'What is Non-Emergency Medical Transportation (NEMT)?',
  answer: 'NEMT is a transportation service provided to individuals who are not in an emergency situation but need assistance getting to and from medical appointments, dialysis, or other healthcare-related destinations.'
}, {
  question: 'How do I schedule a ride?',
  answer: "You can schedule a ride by calling our dispatch center at (555) 123-4567 or by using the 'Request a Ride' button on our homepage. We recommend booking at least 24-48 hours in advance."
}, {
  question: 'Do you provide wheelchair-accessible vehicles?',
  answer: 'Yes, our entire fleet is equipped with modern hydraulic lifts and securement systems to accommodate standard and bariatric wheelchairs safely.'
}, {
  question: 'Will the driver stay with me during my appointment?',
  answer: "Our standard service is door-to-door. However, we can arrange for 'wait and return' service or specialized bedside-to-bedside assistance upon request."
}, {
  question: 'What insurance providers do you work with?',
  answer: 'We work with a wide range of private insurance providers, Medicare, and Medicaid. Please contact our billing department to verify your specific coverage.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="py-20 lg:py-32 bg-white" data-id="element-243">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-244">
        <div className="text-center mb-16" data-id="element-245">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-light rounded-2xl text-brand-blue mb-6" data-id="element-246">
            <HelpCircle size={32} data-id="element-247" />
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-brand-blue mb-6" data-id="element-248">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-249">
            Find answers to common questions about our medical transportation
            services and how we can help you or your loved ones.
          </p>
        </div>

        <div className="space-y-4" data-id="element-250">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-251">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors focus-visible:ring-2 focus-visible:ring-brand-blue outline-none" aria-expanded={openIndex === index} aria-label={`Toggle answer for: ${faq.question}`} data-id="element-252">
                <span className="text-lg font-bold text-brand-blue" data-id="element-253">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="text-brand-blue shrink-0" data-id="element-254" /> : <ChevronDown className="text-gray-400 shrink-0" data-id="element-255" />}
              </button>
              <AnimatePresence data-id="element-256">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-257">
                    <div className="p-6 pt-0 text-gray-700 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-258">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}